import { Button } from '@cokitchen/cokitchen-components';
import LocalModal from '../base/local-modal';
import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTE_KEYS } from 'utils/constants';
import logoutIcon from 'assets/icons/logout-icon.svg';

interface LogoutModalProps {
  show: boolean;
  onClose: () => void;
}

interface LogoutModalFooterProps {
  onCancel: () => void;
  onConfirm: () => void;
}

const LogoutModalFooter: FC<LogoutModalFooterProps> = ({ onCancel, onConfirm }) => (
  <div className='flex gap-2'>
    <Button small color='primary' variant='outline' className='mx-auto' onClick={onCancel}>
      Cancel
    </Button>
    <Button small color='primary' variant='block' className='mx-auto' onClick={onConfirm}>
      Confirm
    </Button>
  </div>
);

const LogoutModal: FC<LogoutModalProps> = ({ show, onClose }) => {
  const navigate = useNavigate();

  const confirmDelete = () => {
    localStorage.clear();
    navigate(`/${ROUTE_KEYS.AUTH}/${ROUTE_KEYS.LOGIN}`);
  };

  return (
    <LocalModal
      isOpen={show}
      description={``}
      titleIconColor='danger'
      onRequestClose={() => onClose()}
      footer={<LogoutModalFooter onCancel={() => onClose()} onConfirm={() => confirmDelete()} />}>
      <div className='flex flex-col justify-center items-center'>
        <img src={logoutIcon} className='mx-auto mb-4' />
        <p className='font-semibold text-[18px]'>Logout</p>

        <p className='text-sm text-[#6F7376] text-center'>Sure you want to leave?</p>
      </div>
    </LocalModal>
  );
};

export default LogoutModal;
